( () => {
  const QUICK_SHOP_SELECTOR = ".ss__quick-shop"
    , CARD_SELECTOR = ".ss__result.ss__result--item, .grid-product, .collection-product"
    , LINK_SELECTOR = "a.grid-product__link, .ss__result__image a, .grid-product__title"
    , SIZE_BTN_SELECTOR = ".grid-product__sizes-list .ss__size__button";
  function getCardAndLink(el) {
      const card = el.closest(CARD_SELECTOR)
        , link = card?.querySelector(LINK_SELECTOR);
      return {
          card,
          link
      }
  }
  function getMetaFromCard(card) {
      const btn = card?.querySelector(SIZE_BTN_SELECTOR);
      if (!btn)
          return null;
      const raw = btn.getAttribute("data-product-data");
      if (!raw)
          return null;
      try {
          return JSON.parse(raw)
      } catch {
          return null
      }
  }
  function pickFirstAvailableVariant(meta) {
      if (!meta?.variants?.length)
          return null;
      const v = meta.variants.find(v2 => v2.available) || null;
      return v ? String(v.id) : null
  }
  function getQuickAddInstance() {
      let qa = document.querySelector("quick-add-component");
      return qa || (qa = document.createElement("quick-add-component"),
      qa.style.display = "none",
      qa.id = "quick-add-bridge",
      document.body.appendChild(qa)),
      qa
  }
  async function openQuickAddFromElement(triggerEl) {
      const {card, link} = getCardAndLink(triggerEl);
      if (!card || !link)
          return;
      const productUrl = link.getAttribute("href");
      if (!productUrl)
          return;
      const meta = getMetaFromCard(card)
        , variantId = pickFirstAvailableVariant(meta)
        , productTitle = meta?.title || card.querySelector(".grid-product__title")?.textContent?.trim() || link.textContent?.trim() || ""
        , quickAdd = getQuickAddInstance();
      triggerEl.classList.add("is-loading"),
      triggerEl.setAttribute("aria-busy", "true");
      try {
          await quickAdd.openWith({
              productUrl,
              variantId,
              productTitle
          })
      } catch (e) {
          console.error(e);
          const sep = productUrl.includes("?") ? "&" : "?";
          window.location.href = variantId ? `${productUrl}${sep}variant=${encodeURIComponent(variantId)}` : productUrl
      } finally {
          triggerEl.classList.remove("is-loading"),
          triggerEl.removeAttribute("aria-busy")
      }
  }
  document.addEventListener("click", evt => {
      const qs = evt.target.closest(QUICK_SHOP_SELECTOR);
      qs && (evt.preventDefault(),  
      evt.stopPropagation(),
      openQuickAddFromElement(qs))
  }
  ),
  document.addEventListener("keydown", evt => {
      const qs = evt.target.closest(QUICK_SHOP_SELECTOR);
      if (!qs)
          return;
      const isEnter = evt.key === "Enter"
        , isSpace = evt.key === " " || evt.code === "Space";
      !isEnter && !isSpace || (evt.preventDefault(),
      evt.stopPropagation(),
      openQuickAddFromElement(qs))
  }
  )
}
)();

